module.exports = __webpack_public_path__ + "img/1749030690_KnmI_en.20f5d934.png";